import React, {useContext, useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {calculateOffset} from '../../common/helper';
import {useDispatch, useSelector} from 'react-redux';
import {
    selectEventsData,
    selectPaymentStatus,
    selectPseudoFlow,
    selectTrackingStatus, setShowInviteModal,
    setShowPaywall
} from '../onboarding/onboardingSlice';
import {MapContext} from './MapContext';
import {sendAnalyticsEvents} from '../../analytics/common';
import {EVENTS} from '../../analytics/events';
import {selectSuccess} from '../paywall/paywallSlice';
import {primaryGreenBtn} from '../../mixins';

const StyledBtnWrapper = styled.div`
  display: none;
`

const StyledButton = styled.button`
  ${primaryGreenBtn};
  min-width: 180px;
  letter-spacing: 0.5px;
  &:focus {
    outline: none;
  }
`


const FakeMarkers = () => {
    const dispatch = useDispatch();
    const {googleMap, lat, lng} = useContext(MapContext);
    const pseudoTrackingDone = useSelector(selectTrackingStatus);
    const isPseudoFlow = useSelector(selectPseudoFlow);
    const [fakeMarker, setFakeMarker] = useState(null);
    const [infoWindow, setInfoWindow] = useState(null);
    const [fakeMainMarker, setFakeMainMarker] = useState(null);
    const {newLat, newLng} = calculateOffset(lat, lng);
    const paymentStatus = useSelector(selectPaymentStatus);
    const isPaymentFinished = useSelector(selectSuccess);
    const buttonRef = useRef();
    const amplitudeEventData = useSelector(selectEventsData);


    const onFakeMarkerClick = () => {
        sendAnalyticsEvents(EVENTS.pseudoUserIconTapped, amplitudeEventData);

        if (paymentStatus) {
            return dispatch(setShowInviteModal(true));
        }

        return dispatch(setShowPaywall(true));
    }

    const createPseudoMainMarker = () => {

        const mainMarker = new window.google.maps.Marker({
            draggable: false,
            id: 'pseudo_main_user',
            icon: {
                url: '../images/default-avatar.png',
                scaledSize: new window.google.maps.Size(80, 90),
            },
            position: {lat, lng},
            map: googleMap
        });

        setFakeMainMarker(mainMarker);

    };

    const createPseudoFakeMarker = () => {
        const pseudoMarker = new window.google.maps.Marker({
            draggable: false,
            animation: window.google.maps.Animation.DROP,
            id: 'pseudo_fake_user',
            icon: {
                url: '../images/blurred-avatar.png',
                scaledSize: new window.google.maps.Size(273, 273),
            },
            position: {lat: newLat, lng: newLng},
            map: googleMap,
        });

        const infoWindow = new window.google.maps.InfoWindow({
            content: buttonRef.current,
            position: {lat: newLat, lng: newLng},
        });

        setFakeMarker(pseudoMarker);
        infoWindow.open(googleMap);
        setInfoWindow(infoWindow);
    };

    const addFakeMarker = () => {
        sendAnalyticsEvents(EVENTS.pseudoUserScreenShown, amplitudeEventData);
        createPseudoFakeMarker()
    }

    useEffect(() => {
        if (fakeMarker && fakeMainMarker && !isPseudoFlow) {
            fakeMarker.setMap(null);
            fakeMainMarker.setMap(null);
        }
    }, [isPseudoFlow, fakeMainMarker, fakeMarker]);

    useEffect(() => {
        if (!isPseudoFlow && infoWindow) {
            infoWindow.close();
        }
    }, [isPseudoFlow, infoWindow])

    useEffect(() => {
        if (isPseudoFlow && pseudoTrackingDone) {
            setTimeout(addFakeMarker, 9000)
        }
    }, [isPseudoFlow, pseudoTrackingDone]);

    useEffect(() => {
        if (isPseudoFlow) {
            setTimeout(createPseudoMainMarker, 7000);
        }
    }, [isPseudoFlow]);

    useEffect(() => {
        fakeMarker && fakeMarker.addListener('click', onFakeMarkerClick);
    }, [fakeMarker]);

    useEffect(() => {
        if (fakeMarker && isPaymentFinished && paymentStatus) {
            window.google.maps.event.clearListeners(fakeMarker, 'click');
            fakeMarker.addListener('click', onFakeMarkerClick);
        }
    }, [fakeMarker, isPaymentFinished, paymentStatus]);

    return (
        <StyledBtnWrapper>
            <StyledButton ref={buttonRef} onClick={onFakeMarkerClick} id='continue-button'>Get Precise Location</StyledButton>
        </StyledBtnWrapper>
    );
};


export default FakeMarkers;

